var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTop2 = function SvgTop2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#top2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F1F4",
    d: "m17.835-.41 3.447 10.377 26.374 45.71 10.168-5.407L34.54 2.918 30-6.064 17.834-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.698-1.353 10.305-5.48 30.344 57.07-10.305 5.479L5.698-1.353Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9E7EC",
    d: "M62.729-1.499 52.56-6.905 22.367 49.882l10.168 5.407 25.652-44.351L62.729-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M63.323-5.815 73.63-.335 43.86 55.65l-10.306-5.48 29.77-55.986Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M40.031 26.672 38.36 57.344l1.672 30c16.735 0 30.344-13.61 30.344-30.344-.016-16.719-13.625-30.328-30.344-30.328Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M9.688 57c0 16.734 13.609 30.344 30.343 30.344V26.672C23.297 26.672 9.688 40.282 9.688 57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A7A7",
    d: "M40.031 31.36 38.36 57.343l1.672 25.312c14.14 0 25.657-11.5 25.657-25.656-.016-14.14-11.516-25.64-25.657-25.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A7A7",
    d: "M14.375 57c0 14.14 11.5 25.656 25.656 25.656V31.36c-14.156 0-25.656 11.5-25.656 25.641Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.594 68.11c7.875-7.063 12.547-12.516 12.547-16.985 0-2.938-1.61-4.703-4.36-4.703-2.125 0-3.875 1.375-5.328 2.984l-3.14-3.14c2.671-2.828 5.25-4.391 9.218-4.391 5.485 0 9.14 3.531 9.14 8.938 0 5.25-4.358 10.906-9.64 16.078 1.453-.157 3.375-.313 4.703-.313h6.313v4.86H30.594v-3.329Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "top2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h80v87.5H0z"
  })))));
};
export default SvgTop2;